import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Button } from "common/src/styles";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ErrorModal(_ref) {
  let {
    isOpen,
    setIsOpen,
    heading = "Error",
    subheading = "There has been a system error during the payout.",
    onTryAgain = () => {
      /**/
    },
    onDone = () => setIsOpen(false),
    tryAgainText = "Try Again",
    doneText = "Done",
    closeOnBackgroundClick = false
  } = _ref;
  return /*#__PURE__*/_jsx(Transition.Root, {
    show: isOpen,
    as: Fragment,
    children: /*#__PURE__*/_jsxs(Dialog, {
      as: "div",
      "data-testid": "error-modal",
      className: "relative z-10",
      onClose: () => {
        if (closeOnBackgroundClick) {
          setIsOpen(false);
        }
      },
      children: [/*#__PURE__*/_jsx(Transition.Child, {
        as: Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/_jsx("div", {
          "data-testid": "backdrop",
          className: "fixed inset-0 bg-grey-400 bg-opacity-75 transition-opacity"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "fixed z-10 inset-0 overflow-y-auto",
        children: /*#__PURE__*/_jsx("div", {
          className: "flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0",
          children: /*#__PURE__*/_jsx(Transition.Child, {
            as: Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            enterTo: "opacity-100 translate-y-0 sm:scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            children: /*#__PURE__*/_jsx(Dialog.Panel, {
              className: "relative bg-white px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6",
              children: /*#__PURE__*/_jsxs("div", {
                className: "sm:flex sm:items-start flex-col",
                children: [/*#__PURE__*/_jsxs("div", {
                  className: "flex flex-row justify-between",
                  children: [/*#__PURE__*/_jsx("div", {
                    className: "w-10 h-10 flex items-center justify-center flex-shrink-0 bg-pink-100 rounded-full",
                    children: /*#__PURE__*/_jsx(InformationCircleIcon, {
                      className: "w-5 h-5 text-pink-500"
                    })
                  }), /*#__PURE__*/_jsxs("div", {
                    className: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left",
                    children: [/*#__PURE__*/_jsx(Dialog.Title, {
                      as: "h3",
                      className: "text-base leading-6 font-semibold text-grey-500",
                      style: {
                        fontFamily: "Libre Franklin",
                        fontSize: 16
                      },
                      "data-testid": "error-heading",
                      children: heading
                    }), /*#__PURE__*/_jsx("div", {
                      className: "mt-2",
                      children: /*#__PURE__*/_jsx("p", {
                        className: "text-sm text-grey-400",
                        "data-testid": "error-message",
                        children: subheading
                      })
                    })]
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  className: "self-end mt-4",
                  children: [/*#__PURE__*/_jsx(Button, {
                    type: "button",
                    $variant: "outline",
                    "data-testid": "tryAgain",
                    onClick: () => {
                      onTryAgain();
                      setIsOpen(false);
                    },
                    className: "mr-4 text-sm px-4",
                    children: tryAgainText
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "button",
                    onClick: () => {
                      onDone();
                      setIsOpen(false);
                    },
                    "data-testid": "done",
                    className: "text-sm px-4",
                    children: doneText
                  })]
                })]
              })
            })
          })
        })
      })]
    })
  });
}